import styled from 'styled-components';

interface IInput {
    width?: string;
    isValid?: boolean;
    isPayment?: boolean;
    isPricedAccordingly?: boolean;
    ol?: boolean;
}

const borderInputs = (isValid?: boolean, isPricedAccordingly?: boolean, ol?: boolean, isPayment?: boolean) => {
    if (isPricedAccordingly) return `2px solid #007443`;
    if (ol) return `2px solid #0E4C54`;
    if (isPayment) return `1px solid #0E4C54`;
    if (isValid) return `2px solid #BEBEBE`;

    return `2px solid #DE2248`;
};

export const Input = styled.div<IInput>`
    height: 26px;
    box-sizing: border-box;
    width: ${({ width }) => width && width};

    input {
        width: inherit;
        height: inherit;
        font-size: 11px;
        padding: 8px 5px;
        background-color: #fff;
        border: ${({ isValid, isPricedAccordingly, ol, isPayment }) => borderInputs(isValid, isPricedAccordingly, ol, isPayment)};

    }


`;